import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializationService } from 'app/app-initialization.service';


@Injectable({
    providedIn: 'root'
})
export class CoordinatesFromAddressService {

    address: any;
    constructor(
        private _httpClient: HttpClient,
        private appConfigService: AppInitializationService,
    ) { }

    getAddress(lat: string,lon: string): Promise<any> {
        var params = new HttpParams();
        params = params.append('format','jsonv2')
        params = params.append('accept-language','tr')
        params = params.append('lat',lat.toString())
        params = params.append('lon',lon.toString())
        return new Promise((resolve, reject) => {
            this._httpClient.get("https://nominatim.openstreetmap.org/reverse",{params:params})
                .subscribe((response: any) => {
                    this.address = response;
                    resolve(response);
                }, reject);
        });
    }

}
